import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

export default class AssignmentRow extends React.Component {
  static propTypes = {
    assignment: PropTypes.shape({
      collaborators: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        imageUrl: PropTypes.string,
        name: PropTypes.string
      })).isRequired,
      listing: PropTypes.shape({
        addressSummary: PropTypes.string,
        statusLabel: PropTypes.string.isRequired,
        statusPillClass: PropTypes.string.isRequired,
        requirement: PropTypes.shape({
          assetTypeLabel: PropTypes.string,
          assignmentTitle: PropTypes.string,
          assignmentTypeLabel: PropTypes.string,
          locationLabel: PropTypes.string
        }).isRequired
      }).isRequired,
      showPath: PropTypes.string.isRequired,
      thumbnailUrl: PropTypes.string.isRequired
    })
  };

  render() {
    const { collaborators, listing, showPath, thumbnailUrl } = this.props.assignment;
    const { assetTypeLabel, assignmentTitle, assignmentTypeLabel, locationLabel } = listing.requirement;

    return (
      <tr className="align-middle">
        <td className="px-2" style={{ width: '1px' }}>
          <img
            alt="Thumb"
            src={thumbnailUrl}
            style={{ maxHeight: '50px', maxWidth: '70px' }}
          />
        </td>
        <td>
          <div
            className={`badge rounded-pill px-4 ${listing.statusPillClass.replace('_', '-')}`}
            name="listing-status-pill"
          >
            {listing.statusLabel}
          </div>
        </td>
        <td>
          <a href={showPath}>{assignmentTitle}</a>
          {listing.addressSummary && <div className="text-muted">{listing.addressSummary}</div>}
        </td>
        <td>{assignmentTypeLabel}</td>
        <td>{assetTypeLabel}</td>
        <td>{locationLabel}</td>
        <td>
          <div className="avatar-group avatar-lg">
            {collaborators.map(user => (
              <OverlayTrigger key={user.id} overlay={this.renderTooltip(user)} placement="bottom">
                <div className="avatar">
                  <img className="avatar-image w-100 h-100 object-fit-cover" src={user.imageUrl} />
                </div>
              </OverlayTrigger>
            ))}
          </div>

        </td>
      </tr>
    );
  }

  renderTooltip(user) {
    return <Tooltip id={`user-${user.id}`}>{user.name}</Tooltip>;
  }
}
